import { cwslapi } from "../index";




// 获取骰子活动信息
export const getActivityInfoApi = (data) => {
  return cwslapi({
    url: "/DiceAct/getActivityInfo",
    method: "post",
    data,
  });
};



// 领取每日任务奖励
export const getDailyTaskApi = (data) => {
  return cwslapi({
    url: "/DiceAct/getDailyTask",
    method: "post",
    data,
  });
}


// 领取巅峰奖励
export const getPeakRewardApi = (data) => {
  return cwslapi({
    url: "/DiceAct/getPeakReward",
    method: "post",
    data,
  });
}


// 获取骰子活动排行榜
export const getRankListApi = (data) => {
  return cwslapi({
    url: "/DiceAct/getRankList",
    method: "post",
    data,
  });
}

// 开始骰子游戏
export const startGameApi = (data) => {
  return cwslapi({
    url: "/DiceAct/startGame",
    method: "post",
    data,
  });
}